import { render, staticRenderFns } from "./tableStyle.vue?vue&type=template&id=122a9c39&scoped=true"
import script from "./tableStyle.vue?vue&type=script&lang=js"
export * from "./tableStyle.vue?vue&type=script&lang=js"
import style0 from "./tableStyle.vue?vue&type=style&index=0&id=122a9c39&prod&scoped=true&lang=css"
import style1 from "./tableStyle.vue?vue&type=style&index=1&id=122a9c39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122a9c39",
  null
  
)

export default component.exports